import UserAvatar from '../components/shared/UserAvatar';
import { NotificationClassComment } from '../../core/interfaces/notification.interface';

const ClassCommentNotification = ({ notification }: { notification: NotificationClassComment }) => {
  const u = notification?.comment?.user;
  return (
    <>
      <UserAvatar src={u?.avatar} name={u?.name} email={u?.email} />
      <div style={{ marginLeft: '5px', textWrap: 'wrap' }}>
        <div style={{ fontSize: '1rem', color: '#c4c4c4' }}>Nuevo comentario en Clase</div>
        <div>{`${u?.name || u?.email || 'Alguien'} comentó en ${notification?.class?.name ?? 'una clase'}`}</div>
        <div style={{ color: '#c2c2c2', height: '20px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {notification?.comment?.content}
        </div>
      </div>
    </>
  );
};

export default ClassCommentNotification;
